<template>
  <div id="applicant-personal-data-form">
    <div class="vx-row">
      <div class="vx-col w-full flex flex-wrap flex-row content-start">
        <h2 class="w-full">Allgemeine Daten</h2>
        <div class="vx-row w-full">
          <!-- <div class="vx-col w-full md:w-1/4">
            <p class="mt-4 text-lg">
              <label class="vs-input--label block mb-3">Landware ID</label>
              <template v-if="internalValue.landwehrId">
                #{{ internalValue.landwehrId }}
              </template>
              <template v-else> - </template>
            </p>
          </div> -->
          <div v-if="internalValue.landwehrId" class="vx-col w-full md:w-1/2">
            <p class="mt-4 text-lg">
              <vs-button
                class="mt-3"
                :disabled="internalValue.l1UpdateRequested"
                @click="l1Update"
                >Neu aus L1 Synchronisieren</vs-button
              >
            </p>
          </div>
        </div>
        <div class="vx-row w-full">
          <div class="vx-col w-full md:w-1/4">
            <DataInput
              :value="internalValue.name"
              required
              class="w-full mt-4"
              label="Name"
              name="name"
              @input="e => updateValue('name', e)"
            />
          </div>
          <div class="vx-col w-full md:w-1/4">
            <DataInput
              :value="internalValue.name2"
              class="w-full mt-4"
              label="Name 2"
              name="name2"
              @input="e => updateValue('name2', e)"
            />
          </div>
          <div class="vx-col w-full md:w-1/4">
            <DataInput
              :value="internalValue.name3"
              class="w-full mt-4"
              label="Name 3"
              name="name3"
              @input="e => updateValue('name3', e)"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="vx-row w-full mt-10">
      <div class="vx-col w-full lg:w-1/2">
        <div class="custom-accordion">
          <div
            class="custom-accordion--item"
            :class="{
              'is-active': 1 === selected
            }"
          >
            <button
              class="custom-accordion--header"
              @click="e => openAddress(e, 1)"
            >
              Postanschrift<i class="far fa-chevron-down"></i>
            </button>
            <div v-if="internalValue.postAddress" class="accordion-content">
              <CompanyAdress v-model="internalValue.postAddress" />
            </div>
            <div v-else class="accordion-content">
              <p class="pt-3 pb-3">Keine Daten vorhanden</p>
              <vs-button @click="internalValue.postAddress = {}"
                >Adresse hinzufügen</vs-button
              >
            </div>
          </div>
          <div
            class="custom-accordion--item"
            :class="{
              'is-active': 2 === selected
            }"
          >
            <button
              class="custom-accordion--header w-full"
              @click="e => openAddress(e, 2)"
            >
              Rechnungsadresse <i class="far fa-chevron-down"></i>
            </button>
            <div v-if="internalValue.billingAddress" class="accordion-content">
              <CompanyAdress v-model="internalValue.billingAddress" />
            </div>
            <div v-else class="accordion-content">
              <p class="pt-3 pb-3">Keine Daten vorhanden</p>
              <vs-button @click="internalValue.billingAddress = {}"
                >Adresse hinzufügen</vs-button
              >
            </div>
          </div>
          <div
            class="custom-accordion--item"
            :class="{
              'is-active': 3 === selected
            }"
          >
            <button
              class="custom-accordion--header"
              @click="e => openAddress(e, 3)"
            >
              Lieferanschrift <i class="far fa-chevron-down"></i>
            </button>
            <div v-if="internalValue.deliveryAddress" class="accordion-content">
              <CompanyAdress v-model="internalValue.deliveryAddress" />
            </div>
            <div v-else class="accordion-content">
              <p class="pt-3 pb-3">Keine Daten vorhanden</p>
              <vs-button @click="internalValue.deliveryAddress = {}"
                >Adresse hinzufügen</vs-button
              >
            </div>
          </div>
        </div>
      </div>
      <div class="vx-col w-full lg:w-1/2">
        <div class="vx-row">
          <div class="vx-col w-full">
            <DataInput
              :value="internalValue.active"
              type="bool"
              class="mt-4 pr-3"
              label="Aktiv"
              name="active"
              @input="e => updateValue('active', e)"
            />
          </div>
          <div class="vx-col w-full">
            <DataInput
              v-model="internalValue.stateID"
              :initial-value="internalValue.state"
              type="model"
              class="mt-4 pr-3"
              label="Status"
              name="state"
              gql-query="companyStates"
            />
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="
        companyhasOfficialEmail &&
          $store.getters['user/hasPermission']('newsletter_companies')
      "
      class="vx-row w-full mt-10"
    >
      <div class="vx-col w-full">
        <div class="custom-accordion">
          <div
            class="custom-accordion--item"
            :class="{
              'is-active': syncOpen
            }"
          >
            <button
              class="custom-accordion--header"
              @click="() => (syncOpen = !syncOpen)"
            >
              Mit Cleverreach synchronisieren
              <i class="far fa-chevron-down"></i>
            </button>
            <div v-if="syncOpen">
              <cleverreach-sync-company :company-id="internalValue.id" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CompanyAdress from "./CompanyAdress";
import DataInput from "@/components/ui/DataInput";
import gql from "graphql-tag";
import CleverreachSyncCompany from "./CleverreachSyncCompany.vue";

export default {
  components: {
    CompanyAdress,
    DataInput,
    CleverreachSyncCompany
  },
  props: {
    value: { type: Object, required: true }
  },
  data: () => ({
    selected: "",
    syncOpen: false
  }),
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    companyhasOfficialEmail() {
      return (
        (this.internalValue.billingAddress || {}).email ||
        (this.internalValue.deliveryAddress || {}).email ||
        (this.internalValue.postAddress || {}).email
      );
    }
  },
  watch: {
    internalValue: {
      deep: true,
      handler(v) {
        this.internalValue = v;
      }
    }
  },
  methods: {
    async l1Update() {
      this.internalValue.l1UpdateRequested = true;
      await this.$apollo.mutate({
        mutation: gql`
          mutation($id: ID!) {
            requestCompanyL1Update(id: $id)
          }
        `,
        variables: {
          id: this.internalValue.id
        }
      });

      this.$vs.notify({
        title: "Synchronisation angefragt",
        text: "Der Vorgang kann bis zu 10 Minuten in Anspruch nehmen.",
        color: "success",
        icon: "query_builder",
        position: "bottom-center"
      });
    },
    updateValue(field, value, subField = null) {
      if (subField) {
        value = Object.assign(this.internalValue[field], {
          [subField]: value
        });
      }

      this.$emit(
        "input",
        Object.assign(this.internalValue, {
          [field]: value
        })
      );
    },
    openAddress(e, id) {
      document.querySelectorAll(".accordion-content").forEach(el => {
        el.style.maxHeight = "0px";
      });

      this.selected = id === this.selected ? null : id;
      if (!this.selected) {
        return;
      }

      let isLoadedInterval = setInterval(() => {
        if (id !== -1) {
          this.$nextTick().then(() => {
            let content = e.target.parentElement.querySelector(
              ".accordion-content"
            );
            content.style.maxHeight = content.scrollHeight + "px";
          });

          clearInterval(isLoadedInterval);
        }
      }, 20);
    }
  }
};
</script>

<style lang="scss" scoped>
.accordion-content {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.2s ease-out;
}
</style>
